import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { classNamesFunction, Icon, anchorProperties, buttonProperties, getNativeProps, mergeStyles, getId, TooltipHost, DirectionalHint, styled } from 'office-ui-fabric-react';
import { NavTeachingBubble } from './NavTeachingBubble/NavTeachingBubble';
var getClassNames = classNamesFunction();
/** This fix is related to a flex bug in IE11 that prevents the browser from calculating proper height in flex
 * children. The work around is to wrap the item in another flex container which this does by restyling
 * the TooltipHost we use within this component. As soon as IE11 support is dropped we can remove this
 * https://github.com/philipwalton/flexbugs#flexbug-3
 */
var FlexTooltipHost = styled(TooltipHost, { root: { display: 'flex' } }, undefined, { scope: 'FlexTooltipHost' });
var NavLinkBase = /** @class */ (function (_super) {
    __extends(NavLinkBase, _super);
    function NavLinkBase(props) {
        var _this = _super.call(this, props) || this;
        _this._linkTipId = getId('linkTip');
        _this._onClick = function (ev) {
            if (_this.props.onClick) {
                _this.props.onClick(ev, _this.props.item);
            }
        };
        _this._setLinkRef = function (linkItem) {
            // we do this with state because getting a ref is not synchronous
            // without this, a TeachingBubble will not show if showTeachingBubble is true initially
            if (_this.state.linkRef !== linkItem) {
                _this.setState({ linkRef: linkItem });
            }
        };
        _this.state = { linkRef: null };
        return _this;
    }
    NavLinkBase.prototype.render = function () {
        var _a = this.props, name = _a.name, hasNestedMenu = _a.hasNestedMenu, isNested = _a.isNested, isNavCollapsed = _a.isNavCollapsed, isExpanded = _a.isExpanded, isSelected = _a.isSelected, hasSelectedNestedLink = _a.hasSelectedNestedLink, styles = _a.styles, primaryIconName = _a.primaryIconName, href = _a.href, forceAnchor = _a.forceAnchor, theme = _a.theme, showTeachingBubble = _a.showTeachingBubble, teachingBubbleProps = _a.teachingBubbleProps, isParentExpanded = _a.isParentExpanded, preserveIconSpace = _a.preserveIconSpace, tooltipProps = _a.tooltipProps, 
        // tslint:disable-next-line:deprecation
        ariaLabel = _a.ariaLabel;
        var classNames = getClassNames(styles, {
            theme: theme,
            isNavCollapsed: isNavCollapsed,
            hasNestedMenu: hasNestedMenu,
            isExpanded: isExpanded,
            isSelected: isSelected,
            hasSelectedNestedLink: hasSelectedNestedLink,
            isNested: isNested,
            hasIcon: !!primaryIconName,
            preserveIconSpace: preserveIconSpace
        });
        var _b = getNativeProps(this.props, href ? anchorProperties : buttonProperties), className = _b.className, title = _b.title, disabled = _b.disabled, nativeProps = __rest(_b, ["className", "title", "disabled"]);
        var iconName = undefined;
        if (hasNestedMenu) {
            iconName = 'ChevronDownMed';
        }
        var navContent = (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames.iconContainer, role: "presentation" }, primaryIconName && React.createElement(Icon, { iconName: primaryIconName, className: classNames.icon })),
            React.createElement("div", { className: classNames.text, tabIndex: -1, role: "presentation", "data-is-focusable": "false" }, name),
            !(isNavCollapsed && !isNested) && (React.createElement(Icon, { iconName: iconName, className: classNames.secondaryIcon, role: "presentation" }))));
        var rootStyle = mergeStyles(classNames.root, className);
        var linkBase = !href && !forceAnchor ? (React.createElement("button", __assign({ "aria-label": ariaLabel }, nativeProps, { onClick: this._onClick, className: rootStyle, ref: this._setLinkRef }), navContent)) : (React.createElement("a", __assign({ "aria-label": ariaLabel }, nativeProps, { onClick: this._onClick, className: rootStyle, ref: this._setLinkRef }), navContent));
        // it wouldn't make sense to show a call out on a nested nav item that isn't visible or transient
        var shouldTeachingBubbleShow = showTeachingBubble && (!isNested || (!isNavCollapsed && isNested && isParentExpanded));
        return (React.createElement(React.Fragment, null,
            disabled ? (linkBase) : (React.createElement(FlexTooltipHost, __assign({ id: this._linkTipId, content: title || (isNavCollapsed && !isNested && name), directionalHint: DirectionalHint.rightCenter }, tooltipProps), linkBase)),
            shouldTeachingBubbleShow && React.createElement(NavTeachingBubble, __assign({ target: this.state.linkRef }, teachingBubbleProps))));
    };
    return NavLinkBase;
}(React.Component));
export { NavLinkBase };
//# sourceMappingURL=NavLinkBase.js.map